import { render, staticRenderFns } from "./veStuRewardEdit.vue?vue&type=template&id=29a629f2&scoped=true"
import script from "./veStuRewardEdit.vue?vue&type=script&lang=js"
export * from "./veStuRewardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a629f2",
  null
  
)

export default component.exports